import { User, FormChangePassword, LoginForm, FormRegister, FormResetPasword } from 'types/auth';
import { apiRequest, ResultAPI } from 'app/requests/apiRequest';
import { buildParams } from 'app/utils/pagination';
import { serverRequest } from './serverRequest';
import { ParsedUrlQuery } from "querystring";

const AUTH_PREFIX = 'api/auth';

export const logoutSystem = async () => {
  await apiRequest(`/${AUTH_PREFIX}/logout`, 'post');
};

export const login = async (user: LoginForm) => {
  return await apiRequest(`/${AUTH_PREFIX}/login`, 'post', user);
};

export const socialUrl = async (type: string) => {
  return await apiRequest(`/${AUTH_PREFIX}/${type}/url`, 'get');
};

export const socialCallback = async (query: ParsedUrlQuery) => {
  const paramsUrl = buildParams(query);
  return await apiRequest(`/${AUTH_PREFIX}/${query.type}/callback${paramsUrl}`, 'get');
};

export const register = async (user: FormRegister) => {
  const result = await apiRequest(`/${AUTH_PREFIX}/register`, 'post', user) as ResultAPI;
  return result.data;
};

export const sendEmailResetPassword = async (user: User) => {
  await apiRequest(`/${AUTH_PREFIX}/password/email`, 'post', user);
};

export const resetPassword = async (user: FormResetPasword) => {
  await apiRequest(`/${AUTH_PREFIX}/password/reset`, 'post', user);
};

export const updatePassword = async (user: FormChangePassword) => {
  await apiRequest(`/${AUTH_PREFIX}/update_password`, 'post', user);
};

export const verify = async (id: string, email: string) => {
  const result = await apiRequest(`/${AUTH_PREFIX}/verify/${id}/${email}`, 'get');
  return result;
};

export const resendEmail = async (email: string) => {
  await apiRequest(`/${AUTH_PREFIX}/resend/${email}`, 'get');
};

export const getInfoUser = async (token: string) => {
  if (token) {
    const response = await serverRequest(`/${AUTH_PREFIX}/user`, 'get', token);
    return response;
  }
};

export const authUser = async () => {
  const user = await apiRequest(`/${AUTH_PREFIX}/user`, 'get');
  return user;
};

export const updateProfile = async (data: User) => {
  const result = await apiRequest(`/api/users/edit`, 'put', data);
  return result;
};

export const updateAdsExpirTime = async () => {
  const result = await apiRequest(`/api/users/ads-expir-time`, 'put', {});
  return result;
};
